import { $, $$, alcance, aviso, avisoHtml, dia, esc, limpiar, noContesto, num, pedir, pedirTodo, puede, repintar, rpc, sb, trabado, trabarSiNoContesto, YO, ordenarPor } from './nucleo';
import { MEDIOS, MONEDAS, MONEDA_CAT, aCatalogo, catalogosCobro, desdeCatalogo,
         frenoCotizacion, frenoPlata, rotuloMoneda } from './cobros';
import { cargarAprobaciones, ofrecerVale, soyAdmin } from './aprobaciones';
import { cargarRendiciones } from './rendiciones';

// =====================================================================
//  VUELTAS · el reparto en moto  (8c en la base, 8d acá)
// =====================================================================
//  Tres oficios en una sola pestaña, cada uno detrás de su permiso:
//   · logística arma la vuelta, le sube pedidos, la despacha y la cierra;
//   · el motoquero ve SÓLO sus paradas y carga qué pasó en cada puerta;
//   · el cajero 2 recibe la plata, y eso vive en la pestaña de Caja,
//     porque es ahí donde la plata entra (D42).
//
//  Nada de esto decide nada: cada botón llama a una función de la base,
//  que es la que dice que sí o que no. Acá sólo se muestra la respuesta.

let VUELTAS = [], PARADAS = [], A_REPARTIR = [], MOTOQUEROS = [], ZONAS = [];
let MEDIOS_CALLE = ['efectivo'];
//  Lo que falta cobrar en la parada abierta y el freno que vio el panel al pintarse.
//  Los lee `guardarParada` sin recalcular, para que frene lo que la persona ve.
let PARADA_FALTA = 0, PARADA_FRENO = '';
//  Saldo NO SABIDO no es cero: `app.saldo_pedido` no es `security definer` y puede
//  volver null; `Number(null || 0)` pintaría "ya está paga" sin haber leído nada (D83).
let PARADA_SALDO_NULO = false;
let PARADA_ABIERTA = null;   // pedido_id de la parada que está desplegada
//  El pedido que se vino a entregar desde Circuito (botón «Entregar»): si no
//  está en MI vuelta en la calle, se abre la vuelta ajena donde está (si la
//  puedo cargar, D184) o la pantalla lo dice en vez de no mostrar nada.
let PEDIDO_BUSCADO: number | null = null;
//  LA PARADA DE UNA VUELTA AJENA (D184): la vuelta en la calle de otra moto cuyas
//  paradas están desplegadas para cargarlas por ella, y si hay que llevar la
//  vista hasta ahí (cuando se llegó desde Circuito).
let AJENA_ABIERTA: number | null = null, AJENA_A_LA_VISTA = false;
let ENVIO_ABIERTO  = null;   // pedido_id con el formulario de dirección abierto
let ENVIO_DATOS    = null;   // lo que ese pedido tiene hoy guardado

//  Por qué una lista está vacía: hay datos · no hay ninguno · no se pudo leer ·
//  no lo podés ver (regla del 4/9). Una bandera por consulta, porque cada una
//  cierra una puerta distinta (regla 11): no leer las zonas no frena una entrega.
let E_VUELTAS = '', E_PARADAS = '', E_REPARTIR = '', E_PEND = '',
    E_MEDIOS_CALLE = '', E_ZONAS = '', E_MOTOS = '';
//  Qué permiso le falta a quien mira, medido sobre la DEFINICIÓN de cada vista
//  (D84). `FALTA_PED_CLI` son los JOIN internos de `v_pedidos_a_repartir` y
//  `v_vuelta_paradas`: `pedidos` y `clientes`.
let FALTA_PEND: string[] = [], FALTA_PED_CLI: string[] = [];
//  El otro eje, el ALCANCE (D85): con `pedido.ver:propio` la lista viene recortada
//  y el chip verde <b>rendida</b> mentiría sobre el resto.
let PEND_RECORTADO = false, REP_RECORTADO = false;
//  Con alcance `propio` el RLS de `vueltas` recorta la lista a las del motoquero:
//  "no hay ninguna vuelta abierta" sería una afirmación que nadie leyó.
let SOLO_MIAS = false;

const faltan = (...claves: string[]) =>
  claves.filter(k => !puede(k.split('.')[0], k.split('.')[1]));
//  Permisos que se tienen pero con alcance recortado (D69, D85).
const recortan = (...claves: string[]) =>
  claves.filter(k => {
    const [r, a] = k.split('.');
    return puede(r, a) && alcance(r, a) !== 'todos';
  });
const motivoV = (e: string, que: string, sinPermiso: string[] = []) =>
  sinPermiso.length
    ? `No podés ver ${que}: te falta <b>${sinPermiso.join('</b> y <b>')}</b>.`
    : e ? `No se pudieron leer ${que} (${esc(e)}).` : '';

//  Quién carga la parada de una vuelta ajena: `entrega.registrar` con alcance
//  `todos`, o quien administra (D184, D166) — lo mismo que mira la base en
//  `cargar_entrega`. El motoquero tiene `propio`: sólo las suyas.
const cargaAjenas = () => alcance('entrega','registrar') === 'todos' || soyAdmin();

//  Si la vuelta es MÍA y está viva (armada o en calle): lo que decide si el RLS
//  me deja ver sus pedidos sin `pedido.ver` (`app.pedido_de_mi_vuelta`).
const esMia = (v: any) => Number(v?.motoquero_id) === Number(YO?.id)
  && (v?.estado === 'armada' || v?.estado === 'en_calle');

//  Quiénes son motoqueros. No se usa v_usuarios porque esa vista pide
//  permiso de gestionar usuarios, y logística no lo tiene ni lo necesita.
//  Tres lecturas en cadena; cualquiera puede fallar y hay que mirar el `error`
//  (si no, falla = "No hay motoqueros activos"). Ninguna tabla se tapa por
//  permiso (RLS `app.es_usuario()`), así que un error es siempre una falla.
async function cargarMotoqueros(){
  E_MOTOS = ''; MOTOQUEROS = [];
  const { data: rol, error: eRol } =
    await pedir(sb.from('roles').select('id').eq('codigo','motoquero').maybeSingle());
  if (eRol){ E_MOTOS = eRol.message; return; }
  //  Sin error y sin fila: todavía no hay rol. Vacío legítimo, no una falla.
  if (!rol) return;
  const { data: ur, error: eUr } =
    await pedir(sb.from('usuario_roles').select('usuario_id').eq('rol_id', rol.id));
  if (eUr){ E_MOTOS = eUr.message; return; }
  const ids = (ur||[]).map(x => x.usuario_id);
  if (!ids.length) return;
  const { data: us, error: eUs } = await pedir(sb.from('usuarios')
    .select('id,nombre,apodo').in('id', ids).eq('activo', true).order('nombre'));
  if (eUs){ E_MOTOS = eUs.message; return; }
  MOTOQUEROS = us || [];
}

export async function cargarVueltas(){
  limpiar('#vueltaMsg'); limpiar('#miVueltaMsg'); limpiar('#repartirMsg');
  //  No hace falta `try`: `catalogosCobro()` no relanza, convierte el rechazo en
  //  `ERROR_CATALOGOS` (lo miran `frenoPlata()` y `frenoMonedas()`) para todas las
  //  pantallas. Un `try` acá taparía el problema de a una pantalla por vez.
  await catalogosCobro();

  const arma  = puede('vuelta','armar');
  const carga = puede('entrega','registrar');
  const ve    = puede('vuelta','ver');
  SOLO_MIAS = ve && alcance('vuelta','ver') !== 'todos';

  //  Los permisos se preguntan ANTES de consultar (regla 5), y sólo donde de
  //  verdad tapan:
  //
  //  · `v_rendiciones_pendientes` llega a `pedido_pagos` (RLS: `pedido.ver` o pedido
  //    de MI vuelta viva). Al cerrarse la vuelta el motoquero deja de ver esos
  //    pagos; sin preguntar, "Sin rendir" pondría <b>rendida</b> a todas.
  FALTA_PEND = faltan('pedido.ver');
  PEND_RECORTADO = !!FALTA_PEND.length || !!recortan('pedido.ver').length;
  //  · `v_pedidos_a_repartir` joinea `clientes` y `pedidos` sin `left` y son pedidos
  //    sin vuelta: la puerta "de mi vuelta" no los alcanza, los dos permisos tapan todo.
  FALTA_PED_CLI = faltan('pedido.ver', 'cliente.ver');
  REP_RECORTADO = !!recortan('pedido.ver', 'cliente.ver').length;
  //
  //  Y cuáles NO se preguntan (D84, regla 11): `v_vueltas` y `v_vuelta_paradas` no
  //  se condicionan a ningún permiso; el RLS deja pasar las vueltas propias y, por
  //  `pedidos_de_mi_vuelta()` y `mis_clientes()`, los pedidos y clientes de mi vuelta.
  //  Ojo: preguntar acá dejaría al motoquero sin pantalla.
  const nada = () => Promise.resolve({ data: null, error: null });

  //  LAS PARADAS, SÓLO DE LAS VUELTAS QUE SE VEN: el servidor corta en mil sin avisar
  //  (D122) y pedir todas traería las más viejas. «Ordenar paradas» arma el orden con
  //  `PARADAS`, que tiene que estar completo. Se piden las de las 40 vueltas de la
  //  lista, enteras (`pedirTodo`).
  const pVu = pedir(sb.from('v_vueltas').select('*').order('fecha', { ascending: false }).order('id', { ascending: false }).limit(40));
  const pPa = pVu.then(vu => {
    const ids = (vu.data || []).map((v: any) => v.id);
    //  Sin vueltas (o sin poder leerlas) no hay paradas; la tarjeta lo dice con `E_VUELTAS`.
    if (vu.error || !ids.length) return { data: [], error: null };
    return pedirTodo(() => sb.from('v_vuelta_paradas').select('*').in('vuelta_id', ids)
      .order('vuelta_id').order('orden').order('pedido_id'),
      { clave: (p: any) => `${p.vuelta_id}·${p.pedido_id}` });
  });
  const [ vu, pa, re, pe, cf ] = await Promise.all([
    pVu,
    pPa,
    //  Lo que falta repartir y rendir también se pide ENTERO: lo cortado no se asigna ni se cobra.
    !arma || FALTA_PED_CLI.length ? nada()
      : pedirTodo(() => sb.from('v_pedidos_a_repartir').select('*')
          , { por: 'pedido_id', orden: ordenarPor('fecha_prevista', 'pedido_id') }),
    FALTA_PEND.length ? nada() : pedirTodo(() => sb.from('v_rendiciones_pendientes').select('*')
          .order('vuelta_id').order('moneda'), { clave: (r: any) => `${r.vuelta_id}·${r.moneda}` }),
    //  `config` la lee cualquier usuario activo: un error es siempre una falla.
    pedir(sb.from('config').select('clave,valor').eq('clave','vuelta.medios_pago'))
  ]);

  E_VUELTAS      = vu.error?.message || '';
  E_PARADAS      = pa.error?.message || '';
  E_REPARTIR     = re.error?.message || '';
  E_PEND         = pe.error?.message || '';
  E_MEDIOS_CALLE = cf.error?.message || '';

  VUELTAS = vu.data || []; PARADAS = pa.data || []; A_REPARTIR = re.data || [];
  const cal = (cf.data||[])[0]?.valor;
  //  D83: un valor de respaldo no habla. `['efectivo']` es una suposición que se ve
  //  como un dato; quien avisa es `frenoParada()`, que mira la BANDERA. Ojo: no
  //  vaciar además esta lista (segunda defensa que ninguna prueba distingue).
  //  Sin error y sin fila la empresa no lo configuró: ahí el respaldo es legítimo.
  MEDIOS_CALLE = Array.isArray(cal) ? cal.map(String) : ['efectivo'];

  //  Reintento por destino: `!X.length` alcanza porque las funciones vacían su lista
  //  al fallar (agregar `|| E_MOTOS` no cambia ningún caso). La bandera se limpia al reintentar.
  if (arma && !MOTOQUEROS.length) await cargarMotoqueros();
  if (arma && !ZONAS.length){
    const { data: z, error: eZ } =
      await pedir(sb.from('zonas').select('id,nombre').eq('activo',true).order('orden'));
    E_ZONAS = eZ?.message || '';
    ZONAS = z || [];
  }

  $('#cardMiVuelta').classList.toggle('oculto', !carga);
  $('#cardVueltas').classList.toggle('oculto', !ve);
  $('#formVuelta').classList.toggle('oculto', !arma);
  $('#cardARepartir').classList.toggle('oculto', !arma);
  $('#cardVueltasCerradas').classList.toggle('oculto', !ve);

  if (carga) pintarMiVuelta();
  if (ve){ pintarVueltas(); pintarCerradas(pe.data || []); }
  if (arma){ pintarSelectMotoqueros(); pintarARepartir(); }
}

function pintarSelectMotoqueros(){
  //  `repintar` y no `.innerHTML =`: asignar no dispara `onchange` y perder lo elegido
  //  es silencioso (regla 12). La opción vacía EXPLICA por qué está vacía.
  repintar('#vuMoto', MOTOQUEROS.map(m =>
    `<option value="${m.id}">${esc(m.apodo || m.nombre)}</option>`).join('')
    || `<option value="">${E_MOTOS
        ? 'No se pudo leer quiénes son motoqueros'
        : 'No hay motoqueros activos'}</option>`);

  //  Freno de armar una vuelta: mira la lectura caída y no un síntoma (select vacío,
  //  que también pasa si no hay motoqueros) (regla 15). Va en su propio div, que
  //  ningún `limpiar` borra.
  $('#vueltaFreno').innerHTML = E_MOTOS
    ? `<div class="aviso a-bad">No se pudo leer quiénes son motoqueros
       (${esc(E_MOTOS)}). <b>No es que no haya: es que no se pudo leer.</b>
       Hasta que se lea, armar una vuelta sería elegir a ciegas a quién se le
       carga la moto. Cambiá de pestaña y volvé, o recargá con Ctrl+F5.</div>`
    : '';
  $('#btnCrearVuelta').disabled = !!E_MOTOS || trabado('#btnCrearVuelta');
}

const CHIP_VUELTA = { armada:'c-warn', en_calle:'c-pen', cerrada:'c-ok' };
const TEXTO_VUELTA = { armada:'armada, todavía en el depósito',
                       en_calle:'en la calle', cerrada:'cerrada' };

const vivas = () => VUELTAS.filter(v => v.estado === 'armada' || v.estado === 'en_calle');

//  Lo que falta cobrar en una parada, cuando puede no saberse: `app.saldo_pedido`
//  devuelve null si el RLS no llega, y `Number(null || 0)` daría un 0 que nadie leyó
//  (D83). Preguntar por null ANTES de convertir, como el arqueo de `caja.ts`.
const cifraSaldo = (saldo: unknown) => saldo === null || saldo === undefined
  ? '<span class="hint">no se sabe</span>'
  : `${num(Number(saldo))} <span class="hint">${esc(rotuloMoneda())}</span>`;

//  Cuántos entregó, cuando puede no saberse: `entregados` cuenta `vuelta_resultados`
//  por LEFT JOIN a `pedido_items`, que sólo se ve si se ve el pedido; en una vuelta
//  ajena o ya cerrada el count vuelve 0 ("no entregó nada"). Vive acá arriba porque
//  el número se imprime en DOS lugares: la tabla de cerradas y la tarjeta viva.
const celdaEntregados = (v: any) => PEND_RECORTADO && !esMia(v)
  ? '<span class="hint">no se sabe</span>' : String(v.entregados);
//  En la tarjeta, con su palabra (sesión 121: sin «(s)»). La celda de la tabla
//  de cerradas sigue con el número solo: la columna ya dice «Entregados».
const entregadosTarjeta = (v: any) => PEND_RECORTADO && !esMia(v)
  ? 'entregados: <span class="hint">no se sabe</span>'
  : `${v.entregados} ${Number(v.entregados) === 1 ? 'entregado' : 'entregados'}`;

//  Una tarjeta por vuelta viva, con sus paradas en orden.
function pintarVueltas(){
  const arma   = puede('vuelta','armar');
  const cierra = puede('vuelta','cerrar');

  $('#vueltasLista').innerHTML = vivas().map(v => {
    const par = PARADAS.filter(p => p.vuelta_id === v.id);
    const filas = par.map((p, i) => `
      <tr>
        <td class="num mono">${p.orden}</td>
        <td class="mono">${esc(p.pedido)}</td>
        <td>${esc(p.cliente)}
            <div class="hint">${esc(p.direccion || 'SIN DIRECCIÓN')}${
              p.zona ? ' · ' + esc(p.zona) : ''}</div></td>
        <td class="num">${p.entregados}/${p.items}</td>
        <td class="num">${cifraSaldo(p.saldo)}</td>
        <td class="fila-acc">${arma ? `
          <button class="b b-sec" data-subir="${p.pedido_id}" data-v="${v.id}"
                  ${i === 0 ? 'disabled' : ''} title="Subir una parada">↑</button>
          <button class="b b-sec" data-bajar="${p.pedido_id}" data-v="${v.id}"
                  ${i === par.length-1 ? 'disabled' : ''} title="Bajar una parada">↓</button>
          <button class="b b-peligro" data-sacar="${p.pedido_id}" data-v="${v.id}">Sacar</button>` : ''}
        </td>
      </tr>`).join('');

    return `<div class="confirmar">
      <div class="conf-tit">Vuelta ${v.numero} de ${esc(v.motoquero)}
        <span class="chip ${CHIP_VUELTA[v.estado] || 'c-pen'}">${TEXTO_VUELTA[v.estado] || esc(v.estado)}</span></div>
      <p class="conf-txt">${v.paradas} ${Number(v.paradas) === 1 ? 'parada' : 'paradas'} · ${v.arriba} ${Number(v.arriba) === 1 ? 'equipo' : 'equipos'} arriba de la moto ·
        ${entregadosTarjeta(v)}${v.notas ? ' · ' + esc(v.notas) : ''}${
        v.salida_en ? ' · salió ' + new Date(v.salida_en).toLocaleTimeString('es-AR',
          {hour:'2-digit',minute:'2-digit',hour12:false}) : ''}</p>
      ${par.length ? `<div class="tw" style="max-height:17.647rem"><table class="t-tarjetas">
        <thead><tr><th>#</th><th>Pedido</th><th>Cliente</th><th class="num">Entregados</th>
                   <th class="num">A cobrar</th><th></th></tr></thead>
        <tbody>${filas}</tbody></table></div>`
      : `<div class="vacio">${E_PARADAS
          ? motivoV(E_PARADAS, 'las paradas de esta vuelta')
          //  Dos números de dos consultas: `v.paradas` (de `v_vueltas`) y `par.length`
          //  (de `v_vuelta_paradas`, recortada por permiso o alcance). Si no coinciden,
          //  la tarjeta se contradice. Se pregunta así para cubrir cualquier causa sin
          //  enumerarlas: un cartel que enumera se desactualiza solo.
          : Number(v.paradas) > 0
          ? `Esta vuelta tiene ${v.paradas} ${Number(v.paradas) === 1 ? 'parada y no se pudo ver' : 'paradas y no se pudieron ver'}${
              FALTA_PED_CLI.length
                ? `: te falta <b>${FALTA_PED_CLI.join('</b> y <b>')}</b>.`
                : '.'}`
          : 'Todavía no tiene ningún pedido. Una moto no sale vacía.'}</div>`}
      ${v.estado === 'en_calle' && Number(v.motoquero_id) !== Number(YO?.id) && cargaAjenas() ? `
      <div class="fila-acc" style="margin-top:0.588rem">
        <button class="b b-sec" data-ajena="${v.id}">${AJENA_ABIERTA === v.id
          ? 'Dejar de cargar por ' + esc(v.motoquero)
          : 'Cargar una parada por ' + esc(v.motoquero)}</button></div>
      ${AJENA_ABIERTA === v.id ? `<div class="aviso a-warn" style="margin-top:0.588rem">Estás
        cargando por <b>${esc(v.motoquero)}</b>. La plata que anotes es de su vuelta
        y la rinde él.</div><div id="ajena-${v.id}"></div>` : ''}` : ''}
      <div class="fila-acc" style="margin-top:0.588rem">
        ${arma && v.estado === 'armada'
          ? `<button class="b b-pri" data-despachar="${v.id}" ${par.length ? '' : 'disabled'}>Despachar</button>` : ''}
        ${cierra && v.estado === 'en_calle'
          ? `<button class="b b-pri" data-cerrarv="${v.id}">Cerrar la vuelta</button>` : ''}
      </div>
    </div>`;
  }).join('') || `<div class="vacio">${
    E_VUELTAS ? motivoV(E_VUELTAS, 'las vueltas')
    //  Con `vuelta.ver:propio` la lista ya viene recortada: no se afirma nada de la empresa.
    : SOLO_MIAS ? 'No hay ninguna vuelta abierta tuya.'
    : 'No hay ninguna vuelta abierta.'}</div>`;

  $$('#vueltasLista [data-ajena]').forEach(b => b.onclick = () => {
    const id = +b.dataset.ajena;
    AJENA_ABIERTA = AJENA_ABIERTA === id ? null : id;
    PARADA_ABIERTA = null;
    repintarParadas();
  });
  const ajena = vivas().find(v => v.id === AJENA_ABIERTA);
  const contAjena = ajena && document.getElementById('ajena-' + ajena.id);
  if (contAjena){
    pintarParadas(ajena, PARADAS.filter(p => p.vuelta_id === ajena.id), contAjena);
    if (AJENA_A_LA_VISTA){ AJENA_A_LA_VISTA = false; contAjena.scrollIntoView({ block: 'start' }); }
  }
  $$('#vueltasLista [data-despachar]').forEach(b => b.onclick = () => despachar(+b.dataset.despachar, b));
  $$('#vueltasLista [data-cerrarv]').forEach(b => b.onclick = () => cerrarVuelta(+b.dataset.cerrarv, b));
  $$('#vueltasLista [data-sacar]').forEach(b => b.onclick = () => sacarPedido(+b.dataset.v, +b.dataset.sacar, b));
  $$('#vueltasLista [data-subir]').forEach(b => b.onclick = () => moverParada(+b.dataset.v, +b.dataset.subir, -1));
  $$('#vueltasLista [data-bajar]').forEach(b => b.onclick = () => moverParada(+b.dataset.v, +b.dataset.bajar, +1));
}

function pintarCerradas(pendientes){
  //  Sin poder leer las vueltas la tabla se desdice entera, no muestra "Ninguna todavía".
  if (E_VUELTAS){
    $('#tblVueltasCerradas').innerHTML =
      `<tr><td colspan="6" class="vacio">${motivoV(E_VUELTAS, 'las vueltas')}</td></tr>`;
    return;
  }

  const sinRendir = {};
  (pendientes||[]).forEach(p => {
    (sinRendir[p.vuelta_id] ??= []).push(`${esc(p.moneda)} ${num(Number(p.a_rendir))}`);
  });

  //  <b>rendida</b> en verde dice "esa plata ya entró": sólo se puede decir si la
  //  lectura contestó de verdad. Ojo con el orden: el recorte invalida la afirmación
  //  NEGATIVA (el chip verde), no el dato positivo —con `pedido.ver:propio` sí vienen
  //  filas y hay que mostrarlas—, y `PEND_RECORTADO` primero dejaría inalcanzable
  //  el chip "no se pudo leer".
  const celdaRendir = (v) =>
    E_PEND
      ? `<span class="chip c-warn">no se pudo leer</span>`
    : sinRendir[v.id]
      ? `<span class="chip c-warn">${sinRendir[v.id].join(' · ')}</span>`
    : PEND_RECORTADO
      ? `<span class="hint" title="${FALTA_PEND.length
          ? 'Te falta ' + esc(FALTA_PEND.join(' y '))
          : 'Sólo ves los pagos de los pedidos que son tuyos'}">no se sabe desde acá</span>`
      : '<span class="chip c-ok">rendida</span>';

  $('#tblVueltasCerradas').innerHTML = VUELTAS
    .filter(v => v.estado === 'cerrada').slice(0, 20).map(v => `
    <tr>
      <td class="hint">${esc(dia(v.fecha))}</td>
      <td class="mono">${v.numero}</td>
      <td>${esc(v.motoquero)}</td>
      <td class="num">${v.paradas}</td>
      <td class="num">${celdaEntregados(v)}</td>
      <td>${celdaRendir(v)}</td>
    </tr>`).join('') || `<tr><td colspan="6" class="vacio">${
      SOLO_MIAS ? 'Ninguna tuya todavía' : 'Ninguna todavía'}</td></tr>`;
}

// ---------- armar y despachar ----------
$('#btnCrearVuelta').onclick = async () => {
  limpiar('#vueltaMsg');
  const moto = $('#vuMoto').value;
  if (!moto) return aviso('#vueltaMsg','bad','Elegí a qué motoquero es la vuelta.');
  const b = $('#btnCrearVuelta'); b.disabled = true;
  const { data, error } = await rpc('crear_vuelta', {
    p_motoquero_id: Number(moto),
    p_notas: ($('#vuNotas').value || '').trim() || null });
  //  Una vuelta que no contestó quizá quedó armada (D91, D92).
  b.disabled = false;
  trabarSiNoContesto('#btnCrearVuelta', error);
  if (error) return aviso('#vueltaMsg','bad', error.message);
  $('#vuNotas').value = '';
  await cargarVueltas();
  aviso('#vueltaMsg','ok', data?.mensaje || 'Vuelta armada.');
};

async function despachar(id, btn){
  limpiar('#vueltaMsg');
  btn.disabled = true;
  const { data, error } = await rpc('salir_vuelta', { p_vuelta_id: id });
  btn.disabled = false;
  //  El error de "todavía no está empaquetado" nombra los pedidos: se muestra tal cual.
  if (error) return aviso('#vueltaMsg','bad', error.message);
  await cargarVueltas();
  aviso('#vueltaMsg','ok', data?.mensaje || 'Vuelta despachada.');
}

async function cerrarVuelta(id, btn){
  limpiar('#vueltaMsg');
  btn.disabled = true;
  const { data, error } = await rpc('cerrar_vuelta', { p_vuelta_id: id });
  btn.disabled = false;
  if (error) return aviso('#vueltaMsg','bad', error.message);
  await cargarVueltas();
  aviso('#vueltaMsg','ok', data?.mensaje || 'Vuelta cerrada.');
  if (puede('rendicion','recibir')) cargarRendiciones();
}

async function sacarPedido(vueltaId, pedidoId, btn){
  limpiar('#vueltaMsg');
  btn.disabled = true;
  const { data, error } = await rpc('quitar_pedido', {
    p_vuelta_id: vueltaId, p_pedido_id: pedidoId, p_motivo: 'sacado de la vuelta' });
  btn.disabled = false;
  if (error) return aviso('#vueltaMsg','bad', error.message);
  await cargarVueltas();
  aviso('#vueltaMsg','ok', data?.mensaje || 'Pedido sacado.');
}

//  Reordenar es mandar la lista entera en el orden nuevo; la base la renumera.
async function moverParada(vueltaId, pedidoId, delta){
  limpiar('#vueltaMsg');
  const orden = PARADAS.filter(p => p.vuelta_id === vueltaId).map(p => p.pedido_id);
  const i = orden.indexOf(pedidoId);
  const j = i + delta;
  if (i < 0 || j < 0 || j >= orden.length) return;
  [orden[i], orden[j]] = [orden[j], orden[i]];
  const { error } = await rpc('ordenar_paradas', { p_vuelta_id: vueltaId, p_pedidos: orden });
  if (error) return aviso('#vueltaMsg','bad', error.message);
  cargarVueltas();
}

// ---------- lo que espera una moto ----------
//  Ojo con la columna de la derecha: "armá una vuelta" sale de `VUELTAS`; con
//  `v_vueltas` caída la lista queda vacía y el consejo mandaría a un camino que la
//  base rechaza (una moto tiene UNA vuelta abierta por vez). Se dice por qué
//  (regla 16: el cartel no puede aconsejar lo que no anda).
function pintarARepartir(){
  const abiertas = vivas().filter(v => v.estado === 'armada' || v.estado === 'en_calle');

  $('#tblARepartir').innerHTML = A_REPARTIR.map(p => {
    const listo = p.empaquetados === p.items;
    const sinDonde = !p.direccion || !p.zona;
    return `
    <tr>
      <td class="mono">${esc(p.codigo)}</td>
      <td>${esc(p.cliente)}</td>
      <td>${p.direccion ? esc(p.direccion) : '<span class="chip c-bad">sin dirección</span>'}
          <div class="hint">${[p.barrio, p.zona].filter(Boolean).map(esc).join(' · ')
            || (p.direccion ? '<span class="chip c-warn">sin zona</span>' : '')}</div></td>
      <td class="hint">${esc(p.horario_texto || '—')}${
        p.fecha_prevista ? '<br>' + esc(dia(p.fecha_prevista)) : ''}</td>
      <td class="num">${p.empaquetados}/${p.items}
          ${listo ? '' : '<div class="hint">falta empaquetar</div>'}</td>
      <td class="num">${cifraSaldo(p.saldo)}</td>
      <td class="fila-acc">
        <button class="b b-sec" data-envio="${p.pedido_id}">Dónde</button>
        ${E_VUELTAS ? '<span class="hint">no se pudieron leer las vueltas</span>'
        : abiertas.length ? `
        <select data-av="${p.pedido_id}" style="width:auto;padding:0.294rem 0.471rem;font-size:.78rem">
          ${abiertas.map(v => `<option value="${v.id}">Vuelta ${v.numero} · ${esc(v.motoquero)}</option>`).join('')}
        </select>
        <button class="b b-pri" data-asignar="${p.pedido_id}" ${sinDonde ? 'disabled title="Sin dirección o sin zona la moto no lo puede llevar"' : ''}>Subir</button>`
        : '<span class="hint">armá una vuelta</span>'}
      </td>
    </tr>
    ${ENVIO_ABIERTO === p.pedido_id ? filaDatosEnvio(p) : ''}`;
  }).join('') || `<tr><td colspan="7" class="vacio">${
    motivoV(E_REPARTIR, 'los pedidos que esperan una moto', FALTA_PED_CLI)
    || (REP_RECORTADO
        ? 'No hay nada esperando una moto que vos puedas ver'
        : 'No hay nada esperando una moto')}</td></tr>`;

  $$('#tblARepartir [data-asignar]').forEach(b => b.onclick = () => {
    const sel = $(`#tblARepartir select[data-av="${b.dataset.asignar}"]`);
    asignarAVuelta(Number(sel.value), +b.dataset.asignar, b);
  });
  $$('#tblARepartir [data-envio]').forEach(b => b.onclick = async () => {
    const id = +b.dataset.envio;
    if (ENVIO_ABIERTO === id){ ENVIO_ABIERTO = null; ENVIO_DATOS = null; pintarARepartir(); return; }
    //  Se lee el pedido, no la vista: la vista no trae teléfono ni quién paga el viaje.
    b.disabled = true;
    const { data, error } = await pedir(sb.from('pedidos')
      .select('id,direccion,barrio,zona_id,telefono_contacto,horario_texto,fecha_prevista,envio_cobra,costo_envio')
      .eq('id', id).maybeSingle());
    b.disabled = false;
    if (error) return aviso('#repartirMsg','bad', error.message);
    //  `maybeSingle()` devuelve `{ data: null, error: null }` si el pedido salió del
    //  RLS o lo anularon. Ojo: no usar `data || {}`; un formulario en blanco
    //  también afirma (regla del 4/9) y guardar borraría todos los campos.
    if (!data) return aviso('#repartirMsg','bad',
      'No se pudo leer este pedido. Puede que lo hayan anulado o que ya no lo ' +
      'veas. No se abre el formulario: llenarlo a ciegas le borraría lo que tiene.');
    ENVIO_ABIERTO = id; ENVIO_DATOS = data;
    pintarARepartir();
  });
  $('#btnEnvioGuardar')?.addEventListener('click', guardarDatosEnvio);
  $('#btnEnvioCerrar')?.addEventListener('click', () => {
    ENVIO_ABIERTO = null; ENVIO_DATOS = null; pintarARepartir(); });
}

//  El formulario de "dónde hay que ir". Muestra lo que el pedido tiene hoy y manda
//  el renglón entero: lo que se deja vacío se borra.
//  Las zonas ilegibles lo traban sólo si el pedido ya tiene zona (el riesgo es
//  borrarla); un pedido "sin zona" es el caso que se arregla acá y no se traba
//  (regla 11: la bandera tan fina como la puerta).
const trabaZona = () => !!E_ZONAS && Number(ENVIO_DATOS?.zona_id) > 0;

function filaDatosEnvio(p){
  const d = ENVIO_DATOS || {};
  const traba = trabaZona();
  return `<tr><td colspan="7"><div class="confirmar">
    <div class="conf-tit">Dónde hay que ir · pedido ${esc(p.codigo)}</div>
    <p class="conf-txt">Sale del domicilio del cliente. Lo que cambies acá queda en el
       pedido, no en el cliente: si se muda, los pedidos viejos siguen diciendo a dónde
       fueron. La zona es la que decide la tarifa del viaje${
       Number(d.costo_envio) > 0 ? `, que hoy es <b>${num(Number(d.costo_envio))}</b>` : ''}.</p>
    <div class="grid g3">
      <label style="grid-column:span 2">Dirección
        <input id="enDireccion" type="text" value="${esc(d.direccion || '')}"></label>
      <label>Barrio<input id="enBarrio" type="text" value="${esc(d.barrio || '')}"></label>
      <label>Zona<select id="enZona"${E_ZONAS ? ' disabled' : ''}>
        <option value="0">${E_ZONAS ? 'no se pudieron leer las zonas' : '(sin zona)'}</option>
        ${ZONAS.map(z => `<option value="${z.id}"${Number(z.id) === Number(d.zona_id) ? ' selected' : ''}>${esc(z.nombre)}</option>`).join('')}
      </select></label>
      <label>Teléfono<input id="enTelefono" type="text" value="${esc(d.telefono_contacto || '')}"
             placeholder="a quién llama el motoquero"></label>
      <label>Horario<input id="enHorario" type="text" value="${esc(d.horario_texto || '')}"
             placeholder="de 14 a 18, después de las 15…"></label>
      <label>Para cuándo<input id="enFecha" type="date" value="${esc(d.fecha_prevista || '')}"></label>
      <label>El viaje lo paga<select id="enCobra">
        <option value="moto"${d.envio_cobra !== 'empresa' ? ' selected' : ''}>La moto (va en el precio del envío)</option>
        <option value="empresa"${d.envio_cobra === 'empresa' ? ' selected' : ''}>La empresa (entra en el V-Pipo)</option>
      </select></label>
    </div>
    ${traba ? `<div class="aviso a-bad">No se pudieron leer las zonas
      (${esc(E_ZONAS)}). <b>No es que no haya: es que no se pudieron leer.</b>
      Este formulario manda el renglón entero, así que guardar ahora le borraría
      al pedido la zona que tiene —y con ella la tarifa del viaje—. Cambiá de
      pestaña y volvé, o recargá con Ctrl+F5.</div>`
    : E_ZONAS ? `<div class="aviso a-warn">No se pudieron leer las zonas
      (${esc(E_ZONAS)}), así que no se le puede poner una. El resto —dirección,
      teléfono, horario— se guarda igual: este pedido no tiene zona, así que no
      hay ninguna que perder.</div>` : ''}
    <div class="fila-acc" style="margin-top:0.588rem">
      <button class="b b-sec" id="btnEnvioCerrar">Cerrar</button>
      <button class="b b-pri" id="btnEnvioGuardar" data-pedido="${p.pedido_id}"${
        traba ? ' disabled' : ''}>Guardar</button>
    </div>
  </div></td></tr>`;
}

async function guardarDatosEnvio(e){
  limpiar('#repartirMsg');
  const btn = e.currentTarget;
  const id  = +btn.dataset.pedido;
  //  La puerta va acá y no sólo en el `disabled` del botón (regla 9): sin zonas
  //  leídas `#enZona` vale "0" y guardar borraría la zona del pedido.
  if (trabaZona()) return avisoHtml('#repartirMsg','bad',
    `No se pudieron leer las zonas (${esc(E_ZONAS)}), así que guardar ahora le
     borraría la zona a este pedido. No se guardó nada.`);
  btn.disabled = true;
  //  `rpc()` Y NO `rpcLee()` (D99, D91): `datos_de_envio` es VOLATILE y ESCRIBE
  //  (`update pedidos`); con el texto de lectura una red caída diría "no pasó nada"
  //  sobre un update que pudo quedar hecho.
  //  El botón SÍ vuelve a habilitarse: reenviar los mismos valores no cambia
  //  `pedidos`; sólo suma una fila repetida en `pedido_eventos` (ninguna pantalla ni
  //  `v_historial_unidad` la lee). Se elige ese ruido antes que dejar muerto el botón.
  const { data, error } = await rpc('datos_de_envio', {
    p_pedido_id: id,
    p_direccion: $('#enDireccion').value.trim(),
    p_barrio:    $('#enBarrio').value.trim(),
    p_zona_id:   Number($('#enZona').value),
    p_telefono:  $('#enTelefono').value.trim(),
    p_horario:   $('#enHorario').value.trim(),
    p_fecha_prevista: $('#enFecha').value || null,
    p_envio_cobra:    $('#enCobra').value
  });
  if (error){ btn.disabled = false; return aviso('#repartirMsg','bad', error.message); }
  ENVIO_ABIERTO = null; ENVIO_DATOS = null;
  await cargarVueltas();
  aviso('#repartirMsg', data?.direccion ? 'ok' : 'warn', data?.mensaje || 'Guardado.');
}

async function asignarAVuelta(vueltaId, pedidoId, btn){
  limpiar('#repartirMsg');
  btn.disabled = true;
  const { data, error } = await rpc('asignar_pedido', {
    p_vuelta_id: vueltaId, p_pedido_id: pedidoId });
  btn.disabled = false;
  if (error) return aviso('#repartirMsg','bad', error.message);
  await cargarVueltas();
  aviso('#repartirMsg','ok', data?.mensaje || 'Pedido asignado.');
}

// =====================================================================
//  La vista de calle
// =====================================================================
//  Lo que necesita alguien parado en la puerta con el casco puesto: a
//  dónde, a quién, a qué teléfono y cuánto hay que cobrar. Y un solo
//  botón para cargar todo lo que pasó ahí.

//  EL BOTÓN «ENTREGAR» DE CIRCUITO (sesión 96): la entrega se carga acá, con
//  lo que se cobró, y no desde el pedido. Circuito trae a esta pestaña con la
//  parada de ese pedido ya abierta. Se aprieta la pestaña verdadera (que es la
//  que llama a `cargarVueltas`), igual que los atajos del menú.
export function irAEntregar(pedidoId: number){
  PARADA_ABIERTA = pedidoId;
  PEDIDO_BUSCADO = pedidoId;
  $('#tabVueltas').click();
}

//  Si el pedido que se vino a entregar no está en la vuelta propia en la calle,
//  se abre la ajena que lo tiene (D184) o se dice — sólo si las dos lecturas
//  contestaron (si no, ya lo dice su cartel).
function avisarBuscado(mia: any, par: any[]){
  if (!PEDIDO_BUSCADO || E_VUELTAS || E_PARADAS) return;
  const esta = mia && mia.estado === 'en_calle' && par.some(p => p.pedido_id === PEDIDO_BUSCADO);
  //  Se usa UNA vez (lo encontró la revisión): si no, el aviso volvía a salir
  //  al guardar la parada o al volver a la pestaña más tarde.
  PEDIDO_BUSCADO = null;
  if (esta){
    $('#cardMiVuelta').scrollIntoView({ block: 'start' });
    return;
  }
  //  D184: si está en la vuelta en la calle de OTRA moto y puedo cargarla, se
  //  abre ésa (la pinta `pintarVueltas`, que corre después).
  const ajena = vivas().find(v => v.estado === 'en_calle' && v !== mia &&
    PARADAS.some(p => p.vuelta_id === v.id && p.pedido_id === PARADA_ABIERTA));
  if (ajena && cargaAjenas() && puede('vuelta','ver')){
    AJENA_ABIERTA = ajena.id;
    AJENA_A_LA_VISTA = true;
    return;
  }
  aviso('#miVueltaMsg', 'warn', 'Ese pedido no está en una vuelta tuya que esté en la calle. ' +
    'La entrega la carga el motoquero de su vuelta, desde su «Mi vuelta».');
}

function pintarMiVuelta(){
  const mia = VUELTAS.find(v => v.motoquero_id === YO.id && v.estado === 'en_calle')
           || VUELTAS.find(v => v.motoquero_id === YO.id && v.estado === 'armada');
  const cont = $('#miVuelta');
  avisarBuscado(mia, mia ? PARADAS.filter(p => p.vuelta_id === mia.id) : []);

  if (!mia){
    //  La afirmación más cara de la pantalla: sólo se dice si la lectura contestó.
    cont.innerHTML = `<div class="vacio">${E_VUELTAS
      ? motivoV(E_VUELTAS, 'tus vueltas') +
        ' <b>No quiere decir que no tengas ninguna</b>: no preguntes acá si te ' +
        'toca salir. Recargá con Ctrl+F5 y, si sigue así, preguntá en el depósito.'
      //  D184: quien carga cualquier vuelta y no tiene una propia, sabe dónde ir.
      : cargaAjenas()
      ? 'No tenés ninguna vuelta propia. Para cargar la parada de otra moto, usá ' +
        '«Cargar una parada por…» en la lista de vueltas.'
      : 'No tenés ninguna vuelta abierta.'}</div>`;
    return;
  }
  if (mia.estado === 'armada'){
    cont.innerHTML = `<div class="aviso a-info">Tu vuelta ${mia.numero} está armada con
      ${mia.paradas} ${Number(mia.paradas) === 1 ? 'parada' : 'paradas'}, pero todavía no salió. Logística la despacha cuando
      esté todo empaquetado.</div>`;
    return;
  }

  pintarParadas(mia, PARADAS.filter(p => p.vuelta_id === mia.id), cont);
}

//  UNA SOLA PARADA ABIERTA EN TODA LA PESTAÑA. «Mi vuelta» y la vuelta ajena
//  (D184) comparten `PARADA_ABIERTA`, y el panel de la parada busca sus campos
//  en TODO el documento (`#paOk`, `.paRes`): si se repintara sólo uno de los
//  dos lugares, el panel viejo del otro quedaría vivo y «Guardar la parada»
//  mezclaría los equipos de dos pedidos. Se repintan siempre los dos.
function repintarParadas(){
  if (puede('entrega','registrar')) pintarMiVuelta();
  if (puede('vuelta','ver')) pintarVueltas();
}

//  LAS PARADAS DE UNA VUELTA EN LA CALLE, con su «Entregar / cargar lo que
//  pasó». Las usan «Mi vuelta» y la vuelta ajena que se carga por otra moto
//  (D184).
function pintarParadas(v: any, par: any[], cont: Element){
  const mia = Number(v.motoquero_id) === Number(YO?.id);
  cont.innerHTML = `
    <div class="hint" style="margin-bottom:0.471rem">Vuelta ${v.numero}${mia ? '' : ' de ' + esc(v.motoquero)} ·
      salió ${v.salida_en ? new Date(v.salida_en).toLocaleTimeString('es-AR',
        {hour:'2-digit',minute:'2-digit',hour12:false}) : '—'} ·
      ${v.arriba} ${Number(v.arriba) === 1 ? 'equipo' : 'equipos'} arriba</div>
    ${par.map(p => {
      //  Ojo: `|| 0` pintaría <b>ya está paga</b> sin saldo leído y el motoquero se iría sin cobrar.
      const saldoNulo = p.saldo === null || p.saldo === undefined;
      const falta = saldoNulo ? 0 : Number(p.saldo);
      const hecho = p.arriba === 0;
      //  Segunda etapa (D181): lo que el motoquero mira primero —qué pedido y
      //  cuánto queda arriba— es la primera línea, en negrita.
      return `<div class="confirmar" style="${hecho ? 'opacity:.6' : ''}">
        <div class="conf-tit">${p.orden}. ${esc(p.cliente)}
          ${hecho ? '<span class="chip c-ok">cargada</span>'
                  : saldoNulo ? '<span class="chip c-warn">no se sabe cuánto hay que cobrar</span>'
                  : falta > 0.005 ? `<span class="chip c-warn">cobrar ${num(falta)} ${esc(rotuloMoneda())}</span>`
                  : '<span class="chip c-ok">ya está paga</span>'}</div>
        <p class="conf-txt">
          <b>Pedido ${esc(p.pedido)} · ${p.arriba} de ${p.items} ${Number(p.items) === 1 ? 'equipo' : 'equipos'} todavía arriba</b><br>
          ${esc(p.direccion || 'SIN DIRECCIÓN — preguntá antes de salir')}${
            p.barrio || p.zona ? '<br>' + esc([p.barrio, p.zona].filter(Boolean).join(' · ')) : ''}
          ${p.telefono_contacto ? `<br><a href="tel:${esc(p.telefono_contacto)}">${esc(p.telefono_contacto)}</a>` : ''}
          ${p.horario_texto ? '<br>' + esc(p.horario_texto) : ''}
        </p>
        ${p.arriba > 0 ? `<div class="fila-acc">
          <button class="b b-pri" data-parada="${p.pedido_id}">${
            PARADA_ABIERTA === p.pedido_id ? 'Cerrar' : 'Entregar / cargar lo que pasó'}</button></div>` : ''}
        ${PARADA_ABIERTA === p.pedido_id ? `<div id="panelParada-${p.pedido_id}"
            style="margin-top:0.588rem"><div class="hint">Buscando los equipos…</div></div>` : ''}
      </div>`;
    }).join('') || `<div class="vacio">${E_PARADAS
      ? motivoV(E_PARADAS, mia ? 'tus paradas' : 'las paradas de esta vuelta') +
        ' <b>No quiere decir que la vuelta salió vacía.</b> Recargá con Ctrl+F5.'
      : 'La vuelta salió sin paradas.'}</div>`}`;

  $$('[data-parada]', cont).forEach(b => b.onclick = () => {
    const id = +b.dataset.parada;
    PARADA_ABIERTA = (PARADA_ABIERTA === id) ? null : id;
    PEDIDO_BUSCADO = null;
    repintarParadas();   //  el panel lo pinta la que lo tiene, si quedó abierto
  });

  if (PARADA_ABIERTA && par.some(p => p.pedido_id === PARADA_ABIERTA))
    pintarPanelParada(v.id, PARADA_ABIERTA);
}

//  El freno del cobro en la calle: `frenoPlata()` más dos causas propias de esta
//  pantalla. Frenan sólo armar un cobro, no la parada entera: registrar lo que no
//  se entregó se puede igual (regla 11).
function frenoParada(medios: any[]){
  const plata = frenoPlata();
  if (plata) return plata;
  if (E_MEDIOS_CALLE)
    return 'No se pudo leer con qué se puede cobrar en la calle (' +
      esc(E_MEDIOS_CALLE) + '). <b>No es que no haya ninguno habilitado: es que ' +
      'no se pudo leer.</b> Ofrecerte efectivo sería suponerlo, y si esta empresa ' +
      'habilitó otra cosa no la verías. Cambiá de pestaña y volvé, o recargá con ' +
      'Ctrl+F5.';
  //  Tercer estado, no es una falla: se leyó bien y no hay ningún medio activo para
  //  la calle. Tiene DOS causas (lista `vuelta.medios_pago` con medios dados de baja,
  //  o ningún medio activo en el sistema) y el cartel no puede nombrar la equivocada
  //  (regla 16).
  if (!medios.length)
    return 'No hay ningún medio de pago habilitado para cobrar en la calle. ' +
      '<b>No es que no se haya podido leer: está leído y no hay ninguno.</b> ' +
      (MEDIOS.length
        ? 'Los que nombra la lista <code>vuelta.medios_pago</code> no están ' +
          'entre los medios de pago activos.'
        : 'No hay ningún medio de pago activo en el sistema.');
  return '';
}

//  Cuándo un freno del cobro traba ADEMÁS la entrega: sólo si el pedido debe o no se
//  sabe si debe ("no se sabe" no es "no debe"). Es una función porque la miran DOS
//  lugares —el cartel del panel y la puerta de `guardarParada`— y tienen que decir lo mismo.
const trabaLaEntrega = (falta: number, saldoNulo: boolean) =>
  saldoNulo || falta > 0.005;

//  Una fila por equipo que está arriba de la moto, más el cobro. La base
//  exige las dos cosas juntas: si falta plata, no deja entregar y pide
//  autorización (D46).
async function pintarPanelParada(vueltaId, pedidoId){
  const panel = document.getElementById('panelParada-' + pedidoId);
  if (!panel) return;
  const par = PARADAS.find(p => p.vuelta_id === vueltaId && p.pedido_id === pedidoId);

  const { data: items, error } = await pedir(sb.from('v_items_pedido')
    //  `es_serializado` distingue "no tiene serie" de "no la podés ver" (LEFT JOIN a
    //  `unidades`, que tapa `stock.ver`).
    .select('id,producto,descripcion,serie,cantidad,estado,es_serializado')
    .eq('pedido_id', pedidoId).order('id'));
  //  Ojo: la guarda se repite DESPUÉS del `await` para evitar una carrera entre dos
  //  paradas. Si se abrió otra, lo que sigue (escribe `PARADA_FALTA`, `PARADA_FRENO`,
  //  `PARADA_SALDO_NULO` y engancha `$('#paOk')`, que busca en TODO el documento)
  //  pisaría el panel nuevo con datos del viejo y cartel y botón se contradirían.
  if (PARADA_ABIERTA !== pedidoId || !panel.isConnected) return;
  if (error){ panel.innerHTML = `<div class="aviso a-bad">${esc(error.message)}</div>`; return; }

  const arriba = (items||[]).filter(i => i.estado === 'en_transito');
  if (!arriba.length){
    panel.innerHTML = '<div class="vacio">No te queda ningún equipo de este pedido arriba.</div>';
    return;
  }

  //  El saldo puede no saberse (cero no es "no se sabe"): no se sugiere monto ni se
  //  frena la parada; la base decide si deja entregar (D46).
  const saldoNulo = PARADA_SALDO_NULO =
    par?.saldo === null || par?.saldo === undefined;
  const falta = saldoNulo ? 0 : Number(par.saldo);
  //  Queda guardado para `guardarParada`, que decide sin los campos dibujados.
  PARADA_FALTA = falta;
  //  Sin catálogos de cobro no se dibuja el formulario de la plata (moneda vacía
  //  mandaría `moneda_id: NaN`).
  const medios = MEDIOS.filter(m => MEDIOS_CALLE.includes(m.codigo));
  const freno = PARADA_FRENO = frenoParada(medios);
  //  Las series llegan por LEFT JOIN desde `unidades` (RLS `stock.ver`, que el
  //  motoquero no tiene): vuelven null (D84). Se avisa una vez, arriba.
  const verSeries = puede('stock','ver');
  const hayAlgoConSerie = arriba.some(i => i.es_serializado);
  const monedaSugerida = MONEDAS.find(m => m.es_base)
                      || MONEDAS.find(m => m.codigo !== MONEDA_CAT) || MONEDAS[0];

  panel.innerHTML = `
    ${!verSeries && hayAlgoConSerie ? `<div class="hint" style="margin-bottom:0.353rem">
      Los números de serie no te los muestra el sistema: te falta <b>stock.ver</b>.
      <b>No es que estos equipos no tengan serie.</b></div>` : ''}
    <div style="display:grid;gap:0.471rem">
      ${arriba.map(i => `
        <div style="border-top:1px solid var(--line);padding-top:0.471rem">
          <b class="mono">${esc(i.producto)}</b> ${esc(i.descripcion || '')}
          ${i.serie ? `<span class="hint mono"> · ${esc(i.serie)}</span>`
            : i.es_serializado && !verSeries ? '<span class="hint"> · serie oculta</span>'
            : ''}
          <div class="grid g2" style="margin-top:0.353rem">
            <label>Qué pasó
              <select class="paRes" data-item="${i.id}">
                <option value="entregado">Se lo entregué</option>
                <option value="no_estaba">No estaba</option>
                <option value="rechazado">No lo quiso recibir</option>
                <option value="reprogramado">Lo dejamos para otro día</option>
              </select></label>
            <label>Por qué <span class="hint">si no lo entregaste</span>
              <input class="paMot" data-item="${i.id}" type="text"
                     placeholder="golpeé, llamé y nadie atendió"></label>
          </div>
        </div>`).join('')}
    </div>

    <div style="border-top:1px solid var(--line);margin-top:0.588rem;padding-top:0.588rem">
      <div class="conf-tit">Lo que cobraste</div>
      ${freno ? `<div class="aviso a-bad">${freno}<br>${trabaLaEntrega(falta, saldoNulo)
        ? `Mientras tanto podés registrar lo que NO entregaste —no estaba, no lo
           quiso recibir, quedó para otro día—, pero no una entrega de este
           pedido: en la calle la plata se carga junto con la entrega, y eso
           necesita el dato que falta.`
        //  Si el pedido no debe nada la entrega SÍ se guarda: el cartel no puede afirmar de más.
        : `La parada se guarda igual: este pedido no debe nada, así que no hay
           ningún cobro que armar.`}</div>`
      : `
      <p class="conf-txt">${saldoNulo
        ? `<b>No se pudo saber cuánto falta cobrar de este pedido.</b> No quiere
           decir que esté pago. Si el cliente te tiene que pagar, cargá lo que
           cobres; si la base no lo acepta, pedí la autorización.`
        : falta > 0.005
        ? `Hay que cobrar <b>${num(falta)} ${esc(rotuloMoneda())}</b>. En la calle se cobra
           ${medios.map(m => esc(m.nombre.toLowerCase())).join(' o ')}: lo demás lo carga
           la oficina. Si no traés la plata, la base no te deja entregar.`
        : 'Este pedido ya está pago. Si igual cobraste algo, cargalo.'}</p>
      <div class="grid g4">
        <label>Medio<select id="paMedio">${
          medios.map(m => `<option value="${m.id}">${esc(m.nombre)}</option>`).join('')
          }</select></label>
        <label>Moneda<select id="paMoneda">${
          MONEDAS.map(m => `<option value="${m.id}" data-cod="${esc(m.codigo)}"${
            monedaSugerida && m.id === monedaSugerida.id ? ' selected' : ''}>${esc(m.codigo)}</option>`).join('')}</select></label>
        <label>Monto<input id="paMonto" type="number" step="0.01" min="0"></label>
        <label>Con cuánto paga <span class="hint">para el vuelto</span>
          <input id="paRecibido" type="number" step="0.01" min="0"></label>
      </div>
      <p class="hint" id="paEquiv" style="margin:0.471rem 0"></p>
      <div id="paCotMsg"></div>`}
      <label>Nota de la parada <span class="hint">opcional</span>
        <input id="paNotas" type="text" placeholder="lo recibió el encargado"></label>
      <div class="fila-acc" style="margin-top:0.588rem">
        <button class="b b-pri" id="paOk" data-v="${vueltaId}" data-p="${pedidoId}">Guardar la parada</button>
      </div>
      <div id="paMsg"></div>
    </div>`;

  const equiv = () => {
    //  Sin formulario no hay nada que calcular (`$('#paMonto')` sería null).
    if (freno) return;
    const monto = Number($('#paMonto').value);
    const cod = $('#paMoneda').selectedOptions[0]?.dataset.cod;
    //  Acá la moneda sugerida es la base (no la de catálogo), así que es la pantalla
    //  donde una cotización ilegible pega más: hay que decirlo.
    //  El botón NO se apaga (guarda también lo no entregado); la puerta está en
    //  `guardarParada`, sobre el cobro.
    const cot = frenoCotizacion(cod);
    if (cot) avisoHtml('#paCotMsg','bad', cot +
      `<br>Así que este cobro no se puede cargar en ${esc(cod)}: probá con ` +
      `${esc(MONEDA_CAT)}, o guardá lo que no entregaste y dejá la entrega para ` +
      'cuando vuelva a andar.');
    else limpiar('#paCotMsg');
    const enCat = aCatalogo(monto, cod);
    $('#paEquiv').textContent = (monto && enCat != null)
      ? `Son ${num(enCat)} ${rotuloMoneda()} al cambio de hoy.` : '';
  };

  //  El monto arranca sugerido y sigue lo que se marca: si no se entregó nada se
  //  borra solo (una sugerencia que nadie miró es un cobro inventado). Si lo
  //  tocaron a mano, no se toca más.
  let montoTocado = false;
  const caduca = () => limpiar('#paMsg');
  const sugerir = () => {
    if (montoTocado || freno) return;
    const hayEntrega = [...$$('.paRes')]
      .some(x => x.value === 'entregado');
    //  Se calcula CONTRA LA MONEDA ELEGIDA, no la del panel al abrir: si no, se
    //  mandaría el monto en pesos con `moneda_id` de dólares (como `prellenar` en
    //  cobros.ts y `prellenarPago` en cuentas.ts).
    const v = desdeCatalogo(falta, $('#paMoneda').selectedOptions[0]?.dataset.cod);
    $('#paMonto').value = (hayEntrega && falta > 0.005 && v != null) ? String(v) : '';
    equiv();
  };
  if (!freno){
    $('#paMonto').oninput = () => { montoTocado = true; caduca(); equiv(); };
    //  Cambiar de moneda vuelve a sugerir aunque el monto se haya tocado: un número
    //  tipeado en una moneda no vale en la otra.
    $('#paMoneda').onchange = () => { montoTocado = false; sugerir(); equiv(); };
  }
  //  Lo que se ofreció se borra antes de seguir (regla 75): el rechazo de la base y la
  //  tarjeta del vale hablan de UNA combinación de resultados y de UN monto; al
  //  cambiar cualquiera de los dos caducan. Si no, el vale seguiría vivo y crearía
  //  una solicitud de «entregar sin cobrar» sobre algo ya cambiado. Se borra el
  //  `#paMsg` entero, donde viven los dos.
  $$('.paRes').forEach(x => x.onchange = () => { caduca(); sugerir(); });
  sugerir();

  $('#paOk').onclick = () => guardarParada(vueltaId, pedidoId);
}

async function guardarParada(vueltaId, pedidoId){
  limpiar('#paMsg');
  //  El resultado de una parada ajena va al cartel de la lista de vueltas, que
  //  es donde está (D184); el de la propia, al de «Mi vuelta».
  const v = VUELTAS.find(x => x.id === vueltaId);
  const cartel = v && Number(v.motoquero_id) !== Number(YO?.id) ? '#vueltaMsg' : '#miVueltaMsg';
  const items = [...$$('.paRes')].map(sel => {
    const motivo = $(`.paMot[data-item="${sel.dataset.item}"]`).value.trim();
    return { item_id: Number(sel.dataset.item), resultado: sel.value, motivo: motivo || null };
  });
  const sinMotivo = items.find(i => i.resultado !== 'entregado' && !i.motivo);
  if (sinMotivo) return aviso('#paMsg','bad','Si no lo entregaste, escribí por qué. Es lo que después se lee.');

  //  La puerta de la plata, donde está el acto: se traba la ENTREGA de un pedido que
  //  todavía debe (la base la rechaza sin cobro). Una parada SIN entregas se guarda
  //  igual (regla 11).
  //  Ojo: el freno sale de `PARADA_FRENO` (lo que vio el panel) y no de llamar de
  //  nuevo a `frenoPlata()`: los catálogos se releen al abrir otras pestañas y,
  //  con el formulario sin dibujar, `$('#paMonto')` sería null (TypeError).
  const freno = PARADA_FRENO;
  if (freno && trabaLaEntrega(PARADA_FALTA, PARADA_SALDO_NULO)
      && items.some(i => i.resultado === 'entregado'))
    return avisoHtml('#paMsg','bad', freno + '<br>Y en la calle no se entrega sin ' +
      'cobrar: hasta que esto se lea, sacá la entrega de este pedido y guardá sólo ' +
      'lo que no entregaste — así como está no se guarda nada.');

  const monto = freno ? 0 : Number($('#paMonto').value);
  //  Puerta del cobro en una moneda sin cotización legible (la base lo rechaza).
  //  Sólo frena el COBRO; lo demás de la parada se registra igual.
  const cotParada = freno ? '' :
    frenoCotizacion($('#paMoneda').selectedOptions[0]?.dataset.cod);
  //  OJO: `monto > 0` NO alcanza. Sin cotización `desdeCatalogo` no convierte y el
  //  monto queda VACÍO: se guardaría la entrega con `cobros: []`. Por eso mira lo
  //  mismo que el freno de arriba: entrega + pedido que debe, no se guarda.
  if (cotParada && (monto > 0 ||
      (trabaLaEntrega(PARADA_FALTA, PARADA_SALDO_NULO)
       && items.some(i => i.resultado === 'entregado'))))
    return avisoHtml('#paMsg','bad', cotParada +
      `<br>Cargá el cobro en ${esc(MONEDA_CAT)}, o sacá la entrega de este pedido ` +
      'y guardá sólo lo que no entregaste: así como está no se guarda nada.');
  const cobros = [];
  if (monto > 0){
    //  Sin comprobar que el select tenga algo elegido, a propósito: `frenoParada()`
    //  ya garantiza al menos un medio real. No agregar un `if` que no puede dar verdadero.
    cobros.push({
      medio_pago_id: Number($('#paMedio').value),
      moneda_id: Number($('#paMoneda').value),
      monto,
      recibido: Number($('#paRecibido').value) || null
    });
  }

  const btn = $('#paOk'); btn.disabled = true;
  const { data, error } = await rpc('cargar_entrega', {
    p_vuelta_id: vueltaId, p_pedido_id: pedidoId,
    p_items: items, p_cobros: cobros,
    p_notas: ($('#paNotas').value || '').trim() || null });

  //  GUARDA DE VIAJE (como en `pintarPanelParada`): hasta 7 segundos con la red caída
  //  (D92) se puede cerrar esta parada o abrir otra y el panel (donde vive `#paMsg`)
  //  se repinta. Sin guarda: `$('#paMsg')` null mataba el handler (se perdía el «no
  //  se sabe si quedó hecho», D91), o el rechazo y el vale caían en el panel ajeno.
  //  Si ya no estamos ahí, el resultado va al cartel de la vuelta.
  const panel = document.getElementById(`panelParada-${pedidoId}`);
  const sigueAbierta = PARADA_ABIERTA === pedidoId && !!panel;

  if (error){
    if (!sigueAbierta) return aviso(cartel,'bad',
      'La parada que estabas guardando no se cargó: ' + error.message);
    //  Una parada que no contestó quizá quedó cargada: el botón no vuelve (D91, D92).
    if (!noContesto(error)) btn.disabled = false;
    aviso('#paMsg','bad', error.message);
    ofrecerVale({ contenedor: '#paMsg', prefijo: 'vale', pedidoId,
                 mensaje: error.message, comoSigue: COMO_SIGUE_EN_LA_CALLE,
                 //  El cartel de la guarda de viaje: no pertenece a ninguna parada.
                 cartelSuelto: cartel });
    return;
  }
  //  Sólo se cierra si la guardada es la abierta (no poner `PARADA_ABIERTA` en null a secas).
  if (sigueAbierta) PARADA_ABIERTA = null;
  await cargarVueltas();
  aviso(cartel,'ok', data?.mensaje || 'Parada cargada.');
}

//  El vale vive en `aprobaciones.ts` (el mismo rechazo llega por el CIRCUITO); lo
//  que decide si la tarjeta aparece lo coteja `scripts/cotejar-catalogos.py` contra
//  `prosrc`. Acá queda dónde se pinta y qué hacer después de que respondan.
const COMO_SIGUE_EN_LA_CALLE =
  'Y si en esta parada llevás más de un equipo, puede que al reintentar te ' +
  'pida otra autorización por lo que falte. Cuando te respondan, volvés a ' +
  'apretar "Guardar la parada". No te vayas de la puerta hasta tener la ' +
  'respuesta.';
